import React from "react";
import styles from "./index.less";

const formatTime = (t: Date) => {
    const min = t
        .getMinutes()
        .toLocaleString("zh", { minimumIntegerDigits: 2 });
    const hour = t.getHours().toLocaleString("zh", { minimumIntegerDigits: 2 });
    const preText = +hour < 12 ? "上午" : "下午";
    return `${preText}  ${hour} : ${min}`;
};

interface IClockStates {
    time: Date;
}

/** PPT演示者视图的时钟组件 */
export default class Clock extends React.Component<{}, IClockStates> {
    private timer: ReturnType<typeof setInterval>;

    public state: IClockStates = {
        time: new Date(),
    };

    public render() {
        const { time } = this.state;
        return <div className={styles.clockText}>{formatTime(time)}</div>;
    }

    public componentDidMount() {
        this.startInterval();
    }

    public componentWillUnmount() {
        clearInterval(this.timer);
    }

    /** 开始计时 */
    private startInterval = () => {
        this.timer = setInterval(() => {
            this.setState({
                time: new Date(),
            });
        }, 1000);
    };
}
